import { 
  collection, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  doc, 
  getDocs, 
  query, 
  orderBy,
  where,
  onSnapshot,
  getDoc
} from 'firebase/firestore';
import { db } from './config';

const COLLECTION_NAME = 'returns';

// Create a return/refund
export const createReturn = async (returnData) => {
  try {
    const docRef = await addDoc(collection(db, COLLECTION_NAME), {
      ...returnData,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    });
    return { success: true, id: docRef.id };
  } catch (error) {
    console.error('Error creating return:', error);
    return { success: false, error: error.message };
  }
};

// Get all returns
export const getReturns = async () => {
  try {
    const q = query(collection(db, COLLECTION_NAME), orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);
    const returns = [];
    querySnapshot.forEach((doc) => {
      returns.push({ id: doc.id, ...doc.data() });
    });
    return { success: true, data: returns };
  } catch (error) {
    console.error('Error getting returns:', error);
    return { success: false, error: error.message, data: [] };
  }
};

// Get returns by bill ID
export const getReturnsByBillId = async (billId) => {
  try {
    const q = query(
      collection(db, COLLECTION_NAME), 
      where('billId', '==', billId),
      orderBy('createdAt', 'desc')
    );
    const querySnapshot = await getDocs(q);
    const returns = [];
    querySnapshot.forEach((doc) => {
      returns.push({ id: doc.id, ...doc.data() });
    });
    return { success: true, data: returns };
  } catch (error) {
    console.error('Error getting returns by bill ID:', error);
    return { success: false, error: error.message, data: [] };
  }
};

// Subscribe to returns (real-time)
export const subscribeToReturns = (callback) => {
  const q = query(collection(db, COLLECTION_NAME), orderBy('createdAt', 'desc'));
  
  return onSnapshot(q, (querySnapshot) => {
    const returns = [];
    querySnapshot.forEach((doc) => {
      returns.push({ id: doc.id, ...doc.data() });
    });
    callback(returns);
  }, (error) => {
    console.error('Error subscribing to returns:', error);
    callback([]);
  });
};

// Update return
export const updateReturn = async (id, returnData) => {
  try {
    const returnRef = doc(db, COLLECTION_NAME, id);
    await updateDoc(returnRef, {
      ...returnData,
      updatedAt: new Date().toISOString()
    });
    return { success: true };
  } catch (error) {
    console.error('Error updating return:', error);
    return { success: false, error: error.message };
  }
};

// Delete return
export const deleteReturn = async (id) => {
  try {
    await deleteDoc(doc(db, COLLECTION_NAME, id));
    return { success: true };
  } catch (error) {
    console.error('Error deleting return:', error);
    return { success: false, error: error.message };
  }
};

// Get return by ID
export const getReturnById = async (id) => {
  try {
    const returnDoc = await getDoc(doc(db, COLLECTION_NAME, id));
    if (returnDoc.exists()) {
      return { success: true, data: { id: returnDoc.id, ...returnDoc.data() } };
    } else {
      return { success: false, error: 'Return not found' };
    }
  } catch (error) {
    console.error('Error getting return:', error);
    return { success: false, error: error.message };
  }
};

const returnsService = {
  createReturn,
  getReturns,
  getReturnsByBillId,
  subscribeToReturns,
  updateReturn,
  deleteReturn,
  getReturnById
};

export default returnsService;
